export const daysBetweenDates = (date1: Date, date2: Date) => {
  return Math.floor(
    // Round down to the nearest whole number
    (new Date(date1).getTime() - new Date(date2).getTime()) / // Get the difference in milliseconds
      (1000 * 60 * 60 * 24), // Convert milliseconds to days
  );
};

export const calculateDaysAgo = (date: Date | null): number => {
  if (!date) return 0;
  const today = new Date();
  const diffTime = Math.abs(today.getTime() - date.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
